import React from "react"
import styled from "styled-components"
import SmartLink from "./smart-link"

import { desktopTextStyles } from "./typography.styles"

const StyledLink = styled(SmartLink)`
  ${desktopTextStyles.LinkText}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  min-height: 46px;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  background-color: var(--burnt-orange);
  color: var(--white);
  ${props => props.styleModifier}
`

const LinkComponent = ({
  href,
  target,
  styleModifier,
  children,
  className,
}) => {
  return (
    <StyledLink
      href={href}
      target={target ?? "_blank"}
      styleModifier={styleModifier}
      className={className}
    >
      {children}
    </StyledLink>
  )
}

export default LinkComponent
